module.exports = __webpack_public_path__ + "img/969.8b9bca5b.png";